export default {
  common: {
    appName: 'Honey Badger Entertainment',
    confirm: 'Confirm',
    cancel: 'Cancel',
    submit: 'Submit',
    save: 'Save',
    usernameRequired: 'Please enter your username!',
    passwordRequired: 'Please enter your password!',
    viewMore: 'View more',
    refreshSuccess: 'Refreshed successfully',
    noMore: 'No more data',
    emptyData: 'No data available',
  },
  footer: { home: 'Home', lottery: 'Lottery', game: 'Booking', video: 'Video', mine: 'Me' },
  lang: { title: 'Language', current: 'Current language' },
  home: {
    recommendedTasks: 'Top Tasks',
    popularRanking: 'Most Popular',
    hotRecommend: 'Hot Picks',
    playCount: 'Views: {count}',
    noticeLoading: 'Loading...',
  },
  game: {
    hallTitle: 'Booking Hall',
    categoryAll: 'All',
  },
  choose: {
    title: 'Companions',
    tabCities: 'City Directory',
    tabProcess: 'Process & Prices',
    privacyNotice: 'The most authentic companions, business escorts and local dates on the entire web. To protect every member\'s privacy, you can only join through our receptionists or a referral from a senior verified member.',
    resourcesQ: 'What options are available?',
    resourcesA: 'Influencers, models, flight attendants, fashion models and college students — if you can imagine it, we can arrange it.',
    scopeQ: 'Service area?',
    scopeA: 'Free local meetups, nationwide fly-in service to any location. Available in all first- and second-tier cities; third-tier cities can be arranged through our receptionists.',
    book: 'Booking',
    contactConcierge: 'Please contact a consultant or receptionist',
    cityNames: {
      beijing: 'Beijing',
      shanghai: 'Shanghai',
      guangzhou: 'Guangzhou',
      shenzhen: 'Shenzhen',
      nanjing: 'Nanjing',
      changsha: 'Changsha',
      chongqing: 'Chongqing',
      xian: 'Xi\'an',
    },
  },
  lottery: {
    gameRecord: 'Task Records',
    orderList: 'Task Slip',
    orderItemDetail: '1 bet X {money} = {money}',
    clearOrder: 'Clear Slip',
    confirmSubmit: 'Confirm & Submit',
    availableBalance: 'Available balance',
    yuan: '',
    currentPick: 'Current picks: ',
    amountPerBet: 'Amount per bet: ',
    amountPlaceholder: 'Enter amount',
    amountInvalid: 'Invalid amount!',
    fillAmount: 'Please enter an amount!',
    selectNumberFirst: 'Please make a selection!',
    insufficientBalance: 'Insufficient balance, please contact customer service to top up!',
    notSelected: 'Not selected',
    contactAdminForTask: 'Please contact the administrator to unlock this task!',
    drawSuccess: 'Draw successful, period: {expect}',
    periodNumber: 'Period',
    betUnit: 'bets',
    totalAmountLabel: 'Total amount: ',
    totalCountLabel: 'Total bets: ',
    drawResult: 'Draw Numbers',
    big: 'Big',
    small: 'Small',
    single: 'Odd',
    doubleNum: 'Even',
    rules: {
      title: 'How to Play',
      tipTitle: 'How to bet',
      tipDetail: 'Pick your numbers from the available sum combinations to place a bet.',
      winTitle: 'Winning criteria',
      winDetail: 'A total of 11~18 across the three drawn numbers is Big; a total of 3~10 is Small.',
      exampleTitle: 'Bet example',
      exampleDetail: 'Bet: Small. Drawn numbers: 123 — result: Small.',
    },
  },
  mine: {
    accountDetail: {
      kind: { recharge: 'Recharge', withdraw: 'Withdraw', game: 'Bet' },
    },
    withdraw: {
      amountLabel: 'Withdrawal amount (CNY)',
      all: 'All',
      limitRule1: '1. Per-transaction limit: minimum {min}, maximum {max}',
      limitRule2: '2. Daily limit: up to {num} withdrawals per day',
      limitRule3: '3. Arrival time: usually within about 5 minutes, as fast as 2 minutes',
      limitTitle: 'Limit details',
      balanceLabel: 'Balance: ',
      submit: 'Withdraw now',
      amountInvalid: 'Please enter a valid amount',
    },
    bindCard: {
      formLabel: 'Please enter your payout card details',
      bankidLabel: 'Card number',
      bankidPlaceholder: 'Enter the real card number',
      bankLabel: 'Bank name',
      bankPlaceholder: 'Select a bank',
      notice: 'Dear user, to keep your funds secure, please use your real name and set a withdrawal password. If the name differs from the account holder, the withdrawal cannot be processed.',
      submit: 'Confirm binding',
      bankidRequired: 'Please enter the card number!',
      bankRequired: 'Please select a bank!',
    },
    setbank: {
      title: 'Payout Card',
      addCard: 'Add payout card',
      tips: 'Tip: please bind a major commercial bank. Contact live support if you need to change it.',
      setNameFirst: 'Please set your name before binding a bank card!',
      setPayPasswordFirst: 'Please set a withdrawal password before binding a bank card!',
    },
    setPayPassword: {
      firstPrompt: 'Enter withdrawal password',
      secondPrompt: 'Enter the withdrawal password again',
      incomplete: 'Please complete the entry',
      mismatch: 'The two passwords do not match!',
    },
    setLoginPassword: {
      oldPassword: 'Old password',
      oldPasswordPlaceholder: 'Enter your old password',
      newPassword: 'New password',
      newPasswordPlaceholder: 'Enter your new password',
      confirmPasswordPlaceholder: 'Enter your new password again',
      incomplete: 'Please complete the entry!',
      mismatch: 'The two passwords do not match',
    },
    setname: {
      nameLabel: 'Name',
      namePlaceholder: 'Enter your real name',
      notice: 'For your account security, the real name must match the name on your bound bank card',
      alreadySet: 'Please do not set it repeatedly!',
      nameRequired: 'Please enter your name!',
    },
    setsex: {
      male: 'Male',
      female: 'Female',
    },
    infomation: {
      avatar: 'Avatar',
      chooseAvatar: 'Choose an avatar',
      realName: 'Real name',
      notSet: 'Not set',
      gender: 'Gender',
      unknown: 'Unknown',
      bindInfo: 'Binding info',
      bound: 'Bound',
      none: 'None',
    },
    index: {
      recharge: 'Deposit',
      withdraw: 'Withdraw',
      myWallet: 'My Wallet',
      details: 'Details',
      balanceLabel: 'Balance: ',
      personalReport: 'Personal Report',
      accountDetail: 'Account Details',
      profileCenter: 'Profile Center',
      notice: 'Announcements',
      customerService: 'Customer Service',
      completeTaskFirst: 'Please complete registration first',
      contactServiceToRecharge: 'Please contact customer service to deposit',
      setPayoutCardFirst: 'Please set up a payout card first',
      featureDisabled: 'This feature is not available yet',
      accountOffline: 'Account offline',
      loginRegister: 'Login / Register',
      loginHint: 'Log in to view',
    },
    setting: {
      basicInfo: 'Basic Information',
      loginPassword: 'Login Password',
      payPassword: 'Payment Password',
      payPasswordAlreadySet: 'Payment password is already set!',
      signOut: 'Sign Out',
    },
    gameRecord: {
      betAmount: 'Bet amount: {money}',
      betTime: 'Bet time: {time}',
      settleTime: 'Settled at: {time}',
    },
    withdrawRecord: {
      amount: 'Withdrawal amount: {money}',
      desc: 'Withdrawal note: {desc}',
      submitTime: 'Requested at: {time}',
      reviewTime: 'Reviewed at: {time}',
    },
    report: {
      profitLabel: 'Profit / Loss',
      formulaTip: 'Profit = winnings - bets + deposits - withdrawals',
      playAmount: 'Bet Amount',
      rechargeAmount: 'Deposit Amount',
      withdrawAmount: 'Withdrawal Amount',
      winAmount: 'Winnings Amount',
    },
    service: {
      contact: 'Contact Us',
      slogan: 'Contact us if you have any questions',
    },
  },
  video: {
    hallTitle: 'Video Theater',
    hotRecommend: 'Hot Recommendations',
    playCount: 'Plays: {count}',
    playCountSuffix: '{count} plays',
    rechargeToWatch: 'Please deposit before watching videos!',
  },
  recharge: {
    title: 'Deposit',
    chooseCoin: 'Select currency',
    address: 'Deposit address',
    copy: 'Copy address',
    copied: 'Copied',
    amount: 'Deposit amount',
    uploadShot: 'Upload transfer screenshot',
    submit: 'Submit deposit request',
    pending: 'Pending review',
    done: 'Credited',
    rejected: 'Rejected',
  },
  payMethod: {
    title: 'Select payment method',
    bankCard: 'Bank card',
    wallet: 'Crypto wallet',
    unbind: 'Unbind',
    bindNew: 'Bind new address',
    confirmUnbind: 'Unbind this payment method?',
    payPassword: 'Withdrawal password',
    wrongPassword: 'Incorrect withdrawal password',
    chooseFirst: 'Please select a payment method first',
  },
  router: {
    Index: { title: 'Home' },
    Home: { title: 'Home' },
    Choose: { title: 'Companions' },
    List: { title: 'Companion List' },
    Profile: { title: 'Companion Profile' },
    Mine: { title: 'Profile' },
    Video: { title: 'Video' },
    Game: { title: 'Games' },
    Login: { title: 'Login' },
    Register: { title: 'Register' },
    ServiceOnline: { title: 'Customer Service' },
    ServicePage: { title: 'Customer Service' },
    Setting: { title: 'Settings' },
    Infomation: { title: 'Basic Information' },
    Setname: { title: 'Change Real Name' },
    Setsex: { title: 'Change Gender' },
    SetPayPassword: { title: 'Payment Password' },
    SetLoginPassword: { title: 'Login Password' },
    Lottery: { title: 'Lottery' },
    Notice: { title: 'Notices' },
    PlayVideo: { title: 'Play Video' },
    Setbank: { title: 'Add Payout Card' },
    BindCard: { title: 'Add Payout Card' },
    Withdraw: { title: 'Withdraw' },
    Recharge: { title: 'Deposit' },
    Personalreport: { title: 'Personal Report' },
    WithdrawRecord: { title: 'Withdrawal Records' },
    AccountDetail: { title: 'Account Details' },
    GameRecord: { title: 'Game Records' },
  },
  captcha: {
    placeholder: 'Image captcha',
    refresh: 'Tap to refresh',
    error: 'Incorrect captcha',
    required: 'Please enter the captcha',
  },
  login: {
    title: 'Login',
    usernamePlaceholder: 'Please enter your username',
    passwordPlaceholder: 'Please enter your password',
    forgotPassword: 'Forgot password?',
    noAccountRegister: 'No account? Register now',
    submit: 'Login',
  },
  register: {
    title: 'Register',
    usernamePlaceholder: 'Please enter a username (6-12 letters or digits)',
    passwordPlaceholder: 'Please enter a login password (6-12 letters or digits)',
    codePlaceholder: 'Please enter the invitation code',
    protocol: 'I have read and agree to all terms of the "Account Opening Agreement"',
    submit: 'Register',
    codeRequired: 'Please enter the invitation code!',
    agreementRequired: 'Please check the box to accept the account opening agreement.',
  },
}
